import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useModuleStrings } from '@platform/modularity/useModuleStrings';
import type { IRecordTypeDefinition } from '@platform/core/types';

/** Підпис швидкого поля (прототип v4): «Напрям», «Призначив» — рядки рушія; решта — підпис поля з рядків модуля. */
export function useQuickFieldLabel(rt: IRecordTypeDefinition): (field: string) => string {
  const { t } = useTranslation();
  const strings = useModuleStrings();
  return useCallback((f: string) => {
    if (f === 'area' || f === 'assignedBy') return t(`quickFields.${f}`);
    return strings.field(rt.key, f, rt.fields.find((x) => x.key === f)?.label);
  }, [rt, strings, t]);
}
